import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';

export interface TopBlockPropsType {
    permissionUpdate: boolean;
    handleSave: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                actions={[
                    {
                        label: translate('userNotificationsDetail.save'),
                        onClick: () => {
                            props.handleSave();
                        },
                        hidden: !props.permissionUpdate,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
